<template>
  <v-card class="mt-6" elevation="2">
    <v-card-title class="font-weight-bold d-flex align-center">
      <v-btn
        outlined
        color="grey lighten-1"
        class="mr-4"
        @click="voltarConfigurarQuestionario"
        title="Voltar para configuração de questionário"
      >
        <v-icon size="20">mdi-arrow-left</v-icon>
        <span class="ml-2" style="font-size: 10px">Voltar</span>
      </v-btn>
      Editar Questionário
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-alert
        v-if="!questionarioSelecionado || !questionarioSelecionado.id"
        type="info"
        text
        border="left"
        colored-border
        color="indigo"
      >
        Salve o questionário primeiro para liberar o cadastro e a edição de questões.
      </v-alert>

      <template v-else>
        <v-btn color="primary" block class="mb-4" @click="carregarQuestoes">Carregar Questões</v-btn>

        <v-list dense v-if="questoes.length" class="questoes-lista">
          <v-list-item v-for="q in questoes" :key="q.id">
            <v-list-item-content>
              <v-list-item-title v-html="q.descricao || q.titulo || 'Sem título'"></v-list-item-title>
              <v-list-item-subtitle>Ordem: {{ q.ordem }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon small color="primary" @click="abrirModalQuestao(q)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small color="error" @click="excluirQuestao(q)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <div v-else class="text-center py-4 grey--text">Nenhuma questão cadastrada ainda.</div>

        <v-card-actions>
          <v-btn block color="success" @click="abrirModalQuestao()">Inserir Nova Questão</v-btn>
        </v-card-actions>
      </template>
    </v-card-text>

    <v-dialog v-model="modalQuestao" max-width="500px">
      <v-card>
        <v-card-title class="headline">{{ questaoEditando.id ? "Editar Questão" : "Nova Questão" }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="questaoEditando.ordem"
            label="Ordem"
            outlined
            class="mb-3"
            type="number"
            :min="1"
            :max="maxOrdem"
          />
          <quill-editor v-model="questaoEditando.descricao" :options="editorOptions" class="mb-3"></quill-editor>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="salvarQuestao">Salvar</v-btn>
          <v-btn text @click="fecharModalQuestao">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="white"></v-progress-circular>
          <div class="mt-3">Processando...</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3500" top>
      {{ snackbarText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EditarQuestionarioQuestoes",
  computed: {
    ...mapGetters({
      questionarioSelecionado: "avaliacao/selecionado",
    }),
  },
  data() {
    return {
      questoes: [],
      loading: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      modalQuestao: false,
      questaoEditando: { id: null, ordem: 1, descricao: "" },
      editorOptions: { theme: "snow", placeholder: "Digite a descrição da questão..." },
      maxOrdem: 100,
    };
  },
  methods: {
    ...mapActions({
      requestQuestao: "avaliacao/requestQuestao",
      atualizarQuestao: "avaliacao/atualizarQuestao",
      criarQuestao: "avaliacao/criarQuestao",
      deletarQuestao: "avaliacao/deletarQuestao",
    }),
    voltarConfigurarQuestionario() {
      this.$router.push({ name: "ConfigurarQuestionario" });
    },
    abrirModalQuestao(questao = null) {
      if (questao) {
        this.questaoEditando = { ...questao };
      } else {
        const ordens = this.questoes.map((q) => Number(q.ordem));
        let nextOrdem = 1;
        while (ordens.includes(nextOrdem)) nextOrdem++;
        this.questaoEditando = { id: null, ordem: nextOrdem, descricao: "" };
      }
      this.modalQuestao = true;
    },
    fecharModalQuestao() {
      this.modalQuestao = false;
    },
    async carregarQuestoes() {
      if (!this.questionarioSelecionado || !this.questionarioSelecionado.id) return;
      this.loading = true;
      try {
        const resp = await this.requestQuestao({ id_questionario: this.questionarioSelecionado.id });
        this.questoes = Array.isArray(resp?.data[0]) ? resp.data[0] : [];
        if (!this.questoes.length) {
          this.snackbarText = "Nenhuma questão encontrada para este questionário.";
          this.snackbarColor = "info";
          this.snackbar = true;
        }
      } catch (e) {
        this.snackbarText = "Erro ao carregar questões.";
        this.snackbarColor = "error";
        this.snackbar = true;
        this.questoes = [];
      }
      this.loading = false;
    },
    async salvarQuestao() {
      this.loading = true;
      const ordens = this.questoes.filter((q) => q.id !== this.questaoEditando.id).map((q) => Number(q.ordem));
      if (ordens.includes(Number(this.questaoEditando.ordem))) {
        this.snackbarText = "Já existe uma questão com essa ordem!";
        this.snackbarColor = "error";
        this.snackbar = true;
        this.loading = false;
        return;
      }
      try {
        if (this.questaoEditando.id) {
          await this.atualizarQuestao({
            id: this.questaoEditando.id,
            id_questionario: this.questionarioSelecionado.id,
            ordem: Number(this.questaoEditando.ordem),
            descricao: this.questaoEditando.descricao,
          });
          this.snackbarText = "Questão atualizada com sucesso!";
        } else {
          await this.criarQuestao({
            id_questionario: this.questionarioSelecionado.id,
            ordem: Number(this.questaoEditando.ordem),
            descricao: this.questaoEditando.descricao,
          });
          this.snackbarText = "Questão criada com sucesso!";
        }
        this.snackbarColor = "success";
        await this.carregarQuestoes();
      } catch (e) {
        this.snackbarText = `Erro ao salvar questão: ${e?.message || e}`;
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
      this.fecharModalQuestao();
    },
    async excluirQuestao(questao) {
      if (!questao || !questao.id) return;
      this.loading = true;
      try {
        await this.deletarQuestao(questao.id);
        this.snackbarText = "Questão excluída com sucesso!";
        this.snackbarColor = "success";
        await this.carregarQuestoes();
      } catch (e) {
        this.snackbarText = "Erro ao excluir questão.";
        this.snackbarColor = "error";
      }
      this.snackbar = true;
      this.loading = false;
    },
  },
  mounted() {
    if (this.questionarioSelecionado && this.questionarioSelecionado.id) {
      this.carregarQuestoes();
    }
  },
};
</script>
